import React , { useEffect, useState }from 'react';
import { TextField, Button, Typography, Paper, Box } from '@mui/material';
import FileBase from 'react-file-base64';
import './styles.scss'; 
import { useDispatch, useSelector } from 'react-redux';
import { createPost, updatePost } from '../../actions/posts';
import styles from './styles';
import ChipInput from '../ChipInput/ChipInput';
import ImageUpload from '../ImageUpload/ImageUpload';
import toBase64 from '../../utils/toBase64';
import CustomInput from './CustomInput';
import theme from '../../muiTheme';

const Form = ({currentId, setCurrentId, onSubmit, additionalFields, mediaPost = true}) => {

    const dispatch = useDispatch();
    const posts = useSelector((state) => state.posts);

    //iterate over posts to find post with _id === currentId
    const post = currentId ? posts.posts.find((item) => item._id === currentId) : null;
    const user = JSON.parse(localStorage.getItem('profile'));

    const [postData, setPostData] = useState({
        title: "",
        message: "",
        tags: [],
        selectedFile: null, //will turn into array for multi-media posts later
        avColors: {}, ////will turn into array for multi-media posts later
        creatorAvatar: user.result.profileImage || null,
        creatorId: user.result._id || null,
        postType: mediaPost ? 'mediaPost' : 'entityPost'
    });

    useEffect(()=>{
        if(post) {
            setPostData(post); 
        };

    }, [post]);

    const handleSubmit = (event) => {
        event.preventDefault();

        //mutate
        let resultingPost = postData;
        resultingPost.name = user?.result?.name; 
        resultingPost.creatorId = user?.result?._id;
        resultingPost.postType = mediaPost ? 'mediaPost' : 'entityPost'

        if(currentId){
            dispatch(updatePost(currentId, resultingPost));

        }else {

            resultingPost.createdAt = new Date(); 
            resultingPost.name = user?.result?.name; 

            dispatch(createPost(resultingPost));
        }

        clear();

        if(typeof onSubmit == 'function'){
            onSubmit(event); 
        }
    }

    const clear = () => {

        setCurrentId(null);
        setPostData({
            title: "",
            message: "",
            tags: [],
            selectedFile: '',
            avColors: ''
        });

    }

    const handleTagAdd = (tag) => {
        setPostData((prevValue)=>{
            return {
                ...prevValue,
                tags: [...prevValue.tags, tag]
            }
        });
    }

    const handleTagDelete = (tagToDelete) => {

        setPostData((prevValue)=>{
            return {
                ...prevValue,
                tags: prevValue.tags.filter((tag)=> tag !== tagToDelete)
            }
        });

    }

    const onSelectedFile = async (file, avColors) => {

        /*BIG TODO: This will be where you make the change from base64 when we 
          finally start storing files using s3 instead of base64 in DB 
          
          Hey! s3 storage solutions cost money, don't judge :( 

            UPDATE: DONE!!!!
          */

        // let base64 = undefined; 

        // try {
        //     base64 = await toBase64(file);
        // } catch (error) {

        //     console.log('base64 error: ', error); 
        // }


        // if (!base64) {

        //     return setPostData( prevValue => {

        //         return {
        //             ...prevValue,
        //             selectedFile: null
        //         }
        //     });

        // }

        console.log('avColors set: ', avColors);

        //Using first image for now -- but future versions will allow for multiple
        setPostData( prevValue => {

            return {
                ...prevValue,
                selectedFile: file,
                avColors: avColors
            }
        });

    }

    if(!user?.result?.name){

        //return a message informing that
        return (
            <Paper className={styles.paper}>

                <Typography variant='h6' align='center'>
                    Please Sign In to Post
                </Typography>

            </Paper>
        );
    }

    return (
        <Box className='paper'
            width={{xs: 'auto', md: '700px'}}
            sx={styles.formContainer}
        >

            <form 
                autoComplete='off' 
                noValidate 
                className='root form' 
                encType='multipart/form-data'
                onSubmit={handleSubmit}
                style={styles.form}
                >

                    <ImageUpload onSelected={onSelectedFile} sx={{marginBottom: '30px'}}/>

                    {
                        mediaPost &&

                        <CustomInput name="title" 
                            variant='standard' 
                            label="Choose a title!" 
                            placeholder='Make them feel it!'
                            fullWidth 
                            value={postData.title}
                            sx={{
                                ...styles.inputField, 
                            }}
                            handleChange={(e)=>setPostData({
                                ...postData,
                                title: e.target.value
                            })}
                        />
                    }
                    

                    <CustomInput name="message" 
                        variant='standard' 
                        label={mediaPost ? "Describe it" : "Your message to the world"}
                        multiline={true}
                        placeholder='No mercy, No surrender!'
                        characterLimit={300}
                        minRows={2}
                        fullWidth 
                        value={postData.message}
                        sx={styles.inputField}
                        handleChange={(e)=>setPostData({
                            ...postData,
                            message: e.target.value
                        })}
                    />

                    {
                        mediaPost &&

                        <ChipInput name="tags" 
                            label="Sprinkle some tags" 
                            multiline={true}
                            fullWidth 
                            value={postData.tags}
                            onDelete={handleTagDelete}
                            onAdd={handleTagAdd}
                            sx={styles.chipInput}
                            onChange={(e)=>setPostData({
                                ...postData,
                                tags: e.target.value
                            })}
                        />
                    }
                    

                    {
                        additionalFields 
                    }

                    {/* <div className="fileInput">
                        <FileBase
                            type="file"
                            multiple={false}
                            onDone={(file)=>{

                                setPostData({
                                    ...postData,
                                    selectedFile: file.base64
                                });
                            }}
                        >

                        </FileBase>
                    </div> */}

                    <Typography variant="body2" sx={{fontSize: '13px' ,padding: '10px 0px', color: theme.palette.gray}}>
                        Please refrain from providing or posting sensitive information.
                    </Typography>

                    <Button 
                        className='buttonSubmit' 
                        variant="main" 
                        color="primary"
                        size="large"
                        disabled={user.result.verified ? false: true}
                        type="submit"
                        sx={styles.button}
                    > 
                        Submit
                    </Button>

                    <Button 
                        variant="faint" 
                        color="secondary" 
                        size="small"
                        onClick={clear}
                        sx={styles.button}
                    > 
                    Clear
                    </Button>

            </form>
        </Box>
    );
}

export default Form;